export type TDrawingOwner = "me" | "other" | undefined

export const isAdminRole = (userRole: string | undefined) => userRole === "Admin" || userRole === "Super Admin"

// REQ-392: Admins and Super Admins get every owner action on another user's drawing/quotation.
// The backend allows the owner whatever their role (#1523). Every owner-action gate goes through this.
export const canActAsOwner = (userRole: string | undefined, drawingOwner: TDrawingOwner) =>
	isAdminRole(userRole) || drawingOwner === "me"

// Whether the quotation tabs of a drawing are reachable at all — the same rule as the actions.
export const canAccessQuotations = canActAsOwner

// The editor names the owner only for an admin working on someone else's drawing (REQ-392).
export const resolveOwnerLabel = (
	userRole: string | undefined,
	drawing: { owner?: string; ownerFirstName?: string | null; ownerLastName?: string | null } | undefined,
): string | null => {
	if (!drawing || drawing.owner !== "other" || !isAdminRole(userRole)) return null
	const name = [drawing.ownerFirstName, drawing.ownerLastName]
		.map((part) => part?.trim())
		.filter(Boolean)
		.join(" ")
	return `Owner: ${name || "another user"}`
}
